import { render, staticRenderFns } from "./CompleteStatistic.vue?vue&type=template&id=0a2b2778&"
import script from "./CompleteStatistic.vue?vue&type=script&lang=js&"
export * from "./CompleteStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CompleteStatistic.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports